import {DashboardCard} from '../dashboard-card/DashboardCard'
import {useTranslation} from '@/translations/i18n'
import {Text} from '@/components/ui/text/Text'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {formatCurrency} from '@/utilities/helpers'
import {useGetDashboardAnalytics} from '../../query/useGetDashboardAnalytics'
import {useParsedSearchParams} from '@/hooks/useParsedSearchParams'
import {DashboardEconomicSearchParams} from '../../types'
import {DashboardSimpleCardSkeleton} from '../dashboard-simple-card-skeleton/DashboardSimpleCardSkeleton'

export const DashboardReimbursedAccessesCard = () => {
    const {t} = useTranslation()
    const {searchParams} = useParsedSearchParams(DashboardEconomicSearchParams)
    const {data, isLoading} = useGetDashboardAnalytics({fields: ['billedAccesses'], ...searchParams})

    if (isLoading) {
        return <DashboardSimpleCardSkeleton title={t('dashboard:reimbursed_accesses')} />
    }

    return (
        <DashboardCard title={t('dashboard:reimbursed_accesses')}>
            <Flexbox direction="column" gap={4} fullWidth>
                <Text palette="neutral" shade="900" size="displaySm" weight={700}>
                    {formatCurrency(data?.billedAccesses?.accesses ?? 0)}
                </Text>
                <ul>
                    <li>
                        <Flexbox align="center" gap={1}>
                            <Text palette="neutral" shade="900" size="textSm" weight={600}>
                                {formatCurrency(data?.billedAccesses?.absences ?? 0)}
                            </Text>
                            <Text palette="neutral" shade="600" size="textSm" weight={400}>
                                {t('dashboard:reimbursed_absences')}
                            </Text>
                        </Flexbox>
                    </li>
                </ul>
            </Flexbox>
        </DashboardCard>
    )
}
